<section class="g-top-thick" *ngIf="(user$ | async) as user">
	<div class="row align-center" *ngIf="(cart$ | async) as cart">
		<div class="small-12 large-6 column">
			<form autocomplete="off" class="form" (ngSubmit)="save(cart)" data-abide novalidate>
				<div class="h-relative">
					<img class="anim anim--fromLeft decorImg decorImg--checkoutBillingAddress"
						 src="/assets/images/decor/balloon_03.png" alt="decor" />
				</div>
				<header class="l-headFrizDecor">
					<h2>{{'Számlázási cím' | transloco }}</h2>
				</header>
				<select [formControl]="addressControl" [compareWith]="formService.compareById">
					<option *ngFor="let address of (addresses$ | async)" [ngValue]="address">
            {{ address }}
					</option>
					<option [ngValue]="newAddress">{{ 'webshop.Új számlázási címet veszek fel' | transloco }}</option>
				</select>
				<span class="form-error is-visible shown" *ngIf="false">{{ 'webshop.Ezt a mezőt ki kell tölteni' | transloco }}</span>

				<div *ngIf="!addressControl.value?.id">
					<p><i>{{ 'webshop.Ha új címet adsz meg, az automatikusan bekerül a címek közé.' | transloco }}</i></p>
					<div class="form form--billingAddress">
						<app-edit-address [address]="newAddress"></app-edit-address>
					</div>
				</div>
				<div class="text-right">
					<img class="l-hand" src="/assets/images/bomo_hand_gray.svg" alt="tovább">
					<button class="btn btn--basic" type="submit">{{ 'webshop.Tovább' | transloco }}</button>
				</div>
			</form>
		</div>
	</div>
</section>
